import React from 'react';

export interface FeedbackState {
  message: string | JSX.Element | null;
  isOpen?: boolean;
  modal?: {
    title: string;
    actionButton: React.ReactNode;
    onCloseAction?: (any?: () => void) => void;
  };
}

const initialFeedbackState: FeedbackState = {
  message: null,
  isOpen: false
};

const feedbackReducer = (
  state: FeedbackState = initialFeedbackState,
  action
) => {
  switch (action.type) {
    case 'SET_FEEDBACK':
      return {
        ...state,
        ...action.payload,
        isOpen: true
      };
    case 'CLEAR_FEEDBACK':
      return initialFeedbackState;
    default:
      return state;
  }
};
export default feedbackReducer;
